import { useEffect } from "react";
import { Nav, Offcanvas } from "react-bootstrap";
import { FaCog, FaTachometerAlt, FaUsers, FaCashRegister, FaBoxes, FaChartLine, FaTags, FaBoxOpen, FaBuilding, FaTruck, FaShoppingCart, FaMoneyBillWave, FaFileInvoice, FaClock, FaUndo } from "react-icons/fa";
import { useSelector } from "react-redux";
import { Link, NavLink } from "react-router-dom";

const AdminSidebar = ({ show, handleClose, handleShow }) => {
  // currentUser state
  const { currentUser } = useSelector(state => state.user);

  // currentUser roleName
  const roleName = currentUser && currentUser?.roleName;

  // Use effect to show the offcanvas by default on large screens
  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 1440px)');
    if (mediaQuery.matches) {
      handleShow(); // Show the sidebar by default on large screens
    }

    const handleResize = () => {
      if (mediaQuery.matches) {
        handleShow(); // Show the sidebar on large screens
      } else {
        handleClose();
      }
    };

    mediaQuery.addEventListener('change', handleResize);
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, [handleShow, handleClose]);

  useEffect(() => {
    if (show) {
      document.body.style.overflow = 'auto';
    } else {
      document.body.style.overflow = '';
    }
  }, [show]);


  return (
    <Offcanvas
      show={show}
      onHide={handleClose}
      className="admin-sidebar"
      scroll={true}
      backdrop={true}
      data-bs-scroll="true"
      data-bs-backdrop="false"
    >
      <Offcanvas.Header className="sidebar-header">
        <div className="sidebar-brand">
          <Link to="/admin" className="text-center">
            <h6 className="m-0 fw-bold">Matrix | Admin</h6>
          </Link>
        </div>
      </Offcanvas.Header>
      <hr className="m-0" />
      <Offcanvas.Body className="sidebar-body">
        <Nav className="mt-0">
          <ul className="nav nav-pills flex-column" data-widget="treeview" data-accordion="false">

            <li className="nav-header"> POINT OF SALE</li>
            {(roleName === "Cashier" || roleName === "SuperAdmin" || roleName === "Supervisor") && (
              <Nav.Item>
                <NavLink to="/admin/pos" className="nav-link" onClick={handleClose}>
                  <FaCashRegister className="me-2" /> POS
                </NavLink>
              </Nav.Item>
            )}
            <Nav.Item>
              <NavLink to="/admin/store-inventory" className="nav-link" onClick={handleClose}>
                <FaBoxes className="me-2" />{currentUser?.store?.name} Inventory
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink to="/admin/sales" className="nav-link" onClick={handleClose}>
                <FaChartLine className="me-2" /> Sales
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink to="/admin/returns" className="nav-link" onClick={handleClose}>
                <FaUndo className="me-2" /> Returns
              </NavLink>
            </Nav.Item>
            {/* {
              roleName !== "Cashier" && (
                <Nav.Item>
                  <NavLink to="/admin/flexpaysales" className="nav-link" onClick={handleClose}>
                    <FaChartLine className="me-2" /> Flex Pay
                  </NavLink>
                </Nav.Item>
              )
            } */}

            {(roleName === "SuperAdmin" || roleName === "Admin" || roleName === "Supervisor") && (
              <>
                {roleName === "SuperAdmin" && (
                  <>
                    <Nav.Item>
                      <NavLink to="/admin/z-reports" className="nav-link" onClick={handleClose}>
                        <FaFileInvoice className="me-2" /> Z Reports
                      </NavLink>
                    </Nav.Item>
                    <li className="nav-header">Dashboard</li>
                    <Nav.Item>
                      <NavLink to="/admin/dashboard" className="nav-link" onClick={handleClose}>
                        <FaTachometerAlt className="me-2" /> Dashboard
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink to="/admin/reports" className="nav-link" onClick={handleClose}>
                        <FaChartLine className="me-2" /> Reports
                      </NavLink>
                    </Nav.Item>
                  </>
                )}
                <Nav.Item>
                  <NavLink to="/admin/customers" className="nav-link" onClick={handleClose}>
                    <FaUsers className="me-2" /> Customers
                  </NavLink>
                </Nav.Item>
                <li className="nav-header">Inventory Management</li>
                <Nav.Item>
                  <NavLink to="/admin/subcategories" className="nav-link" onClick={handleClose}>
                    <FaTags className="me-2" /> Subcategories
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink to="/admin/products" className="nav-link" onClick={handleClose}>
                    <FaBoxOpen className="me-2" /> Products
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink to="/admin/inventory" className="nav-link" onClick={handleClose}>
                    <FaBoxes className="me-2" /> Inventory
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink to="/admin/purchases" className="nav-link" onClick={handleClose}>
                    <FaShoppingCart className="me-2" /> Purchases
                  </NavLink>
                </Nav.Item>
                <Nav.Item>
                  <NavLink to="/admin/expenses" className="nav-link" onClick={handleClose}>
                    <FaMoneyBillWave className="me-2" /> Expenses
                  </NavLink>
                </Nav.Item>
                {
                  (roleName === "SuperAdmin" || roleName === "Admin") && (
                    <>
                      <li className="nav-header">Administration</li>
                      <Nav.Item>
                        <NavLink to="/admin/staff" className="nav-link" onClick={handleClose}>
                          <FaUsers className="me-2" /> Staff
                        </NavLink>
                      </Nav.Item>
                      <Nav.Item>
                        <NavLink to="/admin/shifts" className="nav-link" onClick={handleClose}>
                          <FaClock className="me-2" /> Shifts
                        </NavLink>
                      </Nav.Item>
                      <Nav.Item>
                        <NavLink to="/admin/users" className="nav-link" onClick={handleClose}>
                          <FaUsers className="me-2" /> Users
                        </NavLink>
                      </Nav.Item>
                      <Nav.Item>
                        <NavLink to="/admin/stores" className="nav-link" onClick={handleClose}>
                          <FaBuilding className="me-2" /> Stores
                        </NavLink>
                      </Nav.Item>
                      <Nav.Item>
                        <NavLink to="/admin/suppliers" className="nav-link" onClick={handleClose}>
                          <FaTruck className="me-2" /> Suppliers
                        </NavLink>
                      </Nav.Item>
                    </>
                  )
                }
                {roleName === "SuperAdmin" && (
                  <>
                    <li className="nav-header">Settings</li>
                    <Nav.Item>
                      <NavLink to="/admin/settings" className="nav-link" onClick={handleClose}>
                        <FaCog className="me-2" /> Settings
                      </NavLink>
                    </Nav.Item>
                    <Nav.Item>
                      <NavLink to="/admin/organization-profile" className="nav-link" onClick={handleClose}>
                        <FaBuilding className="me-2" /> Organization Profile
                      </NavLink>
                    </Nav.Item>
                  </>
                )}
              </>
            )}
          </ul>
        </Nav>

      </Offcanvas.Body>
    </Offcanvas>
  )
}
export default AdminSidebar